import React, { useState, useEffect, Suspense, useRef } from 'react'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { CssBaseline, CircularProgress } from '@material-ui/core'
import { BrowserRouter as Router } from 'react-router-dom'
import firebase from '../firebase'
import SwitchRoutes from './routes'
import { useOnClickOutside } from './hooks'
import { darkColors } from './colorsDark'
import { lightColors } from './colorsLight'
import Burger from '../Burger'
import Openburger from '../Burger/Openburger'
import HamburgerMenu from '../Menu'
import FocusLock from 'react-focus-lock'
import { toast, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import '../../i18n'
import LanguageSelector from '../../languageSelector'
import './styles.css'
import Themeswitch from '../Theme'
import Logo from '../Theme/logo'
import BackButton from '../Theme/backButton'
import {
	blueGrey, indigo, grey
} from '@material-ui/core/colors'
import { Provider } from "../useGlobalState"
import useMediaQuery from '@material-ui/core/useMediaQuery'

const App = () => {
	const [firebaseInitialized, setFirebaseInitialized] = useState(false)
	const [isLogged, setIsLogged] = useState(false)
	const [mode, setMode] = useState('dark')
	const [primcolor, setPrimcolor] = useState('')
	const [primarycolor, setPrimarycolor] = useState(blueGrey)
	const [mainShade, setMainshade] = useState(400)
	const [mainshade] = useState(400)
	const [darkshade] = useState(200)
	const [papershade, setPapershade] = useState(200)
	const [surfacecolor, setSurfacecolor] = useState('#121212')
	const [seccolor, setSeccolor] = useState('')
	const [secondarycolor, setSecondarycolor] = useState(indigo)
	const [theme, setTheme] = useState()
	const [open, setOpen] = useState(false)
	const [isActive] = useState(window.localStorage.getItem('isactive'))
	const node = useRef()
	const menuId = "main-menu"

	useOnClickOutside(node, () => setOpen(false))

	const checkMode = useMediaQuery('(prefers-color-scheme: dark)')

	useEffect(() => {
		if (checkMode === true) {
			localStorage.setItem('darkmode', true)
			localStorage.setItem('projectBox', '#303030')
			setMode('dark')
			setMainshade(200)
			setPapershade(900)
			setSurfacecolor('#121212')
			darkColors()
		} else {
			localStorage.setItem('darkmode', false)
			localStorage.setItem('projectBox', '#e0e0e0')
			setMode('light')
			setMainshade(400)
			setSurfacecolor('#f9f9f9')
			setPapershade(200)
			lightColors()
		}
	}, [checkMode])

	useEffect(() => {
		if (window.localStorage.getItem('apptitle') !== 'undefined') {
			document.title = window.localStorage.getItem('apptitle')
		} else {
			document.title = 'EasyBackup Firestore'
		}
	}, [])

	useEffect(() => {
		setTimeout(() => {
			localStorage.setItem('isactive', false)
		}, 60000);
	}, [isActive])

	useEffect(() => {
		setTheme({
			palette: {
				primary: {
					main: primarycolor[mainShade],
				},
				secondary: {
					main: secondarycolor[mainShade],
				},
				background: {
					paper: grey[papershade],
					default: surfacecolor,
				},
				type: mode,
			}
		})
	}, [primarycolor, secondarycolor, mainShade, papershade, surfacecolor, mode])

	const toggleDarkTheme = () => {
		localStorage.setItem('menuopen', localStorage.getItem('menuopen') === "true" ? "false" : "true")
		let newPaletteType = theme.palette.type === "light" ? "dark" : "light"
		setTheme({
			palette: {
				primary: {
					main: primarycolor[mainshade],
				},
				secondary: {
					main: secondarycolor[mainshade],
				},
				background: {
					paper: grey[papershade],
				},
				type: newPaletteType,
			}
		})
		if (newPaletteType === 'dark') {
			setTheme({
				palette: {
					primary: {
						main: primarycolor[darkshade],
					},
					secondary: {
						main: secondarycolor[darkshade],
					},
					background: {
						paper: grey[900],
						default: '#121212'
					},
					text: {
						primary: "rgba(255, 255, 255, 0.87)",
						secondary: "rgba(255, 255, 255, 0.54)",
						disabled: "rgba(255, 255, 255, 0.38)",
						hint: "rgba(255, 255, 255, 0.38)"
					},
					type: newPaletteType,
				}
			})
			localStorage.setItem('projectBox', '#303030')
			darkColors()
		} else if (newPaletteType === 'light') {
			setTheme({
				palette: {
					primary: {
						main: primarycolor[mainshade],
					},
					secondary: {
						main: secondarycolor[mainshade],
					},
					background: {
						paper: grey[200],
						default: '#f9f9f9'
					},
					type: newPaletteType,
				}
			})
			localStorage.setItem('projectBox', '#e0e0e0')
			lightColors()
		}
	}

	useEffect(() => {
		firebase.isInitialized().then(val => {
			setFirebaseInitialized(val)
		})
		firebase.auth.onAuthStateChanged(function (user) {
			if (user) {
				setIsLogged(true)
			} else {
				setIsLogged(false)
			}
		})
	}, [])

	useEffect(() => {
		firebase.db.collection('backupsettings').doc('settings').get()
			.then((doc) => {
				if (doc.exists) {
					localStorage.setItem('apptitle', doc.data().apptitle)
					localStorage.setItem('language', doc.data().language)
					localStorage.setItem('logo', doc.data().logo)
					localStorage.setItem('background', doc.data().bgimage)
					setPrimcolor('#ab47bc')
					setPrimarycolor(blueGrey)
					setSeccolor('#26a69a')
					setSecondarycolor(indigo)
				} else {
					localStorage.setItem('apptitle', 'Firestore Easy Backup')
					localStorage.setItem('language', 'en')
					localStorage.setItem('logo', Logo)
					localStorage.setItem('background', '')
					setPrimcolor('#ab47bc')
					setPrimarycolor(blueGrey)
					setSeccolor('#26a69a')
					setSecondarycolor(indigo)
				}
			})
	}, [])

	toast.configure({
		position: "top-center",
		autoClose: 1500,
		draggable: false,
		transition: Slide,
	})

	const reducer = (state, action) => {
		switch (action.type) {
			case 'changeAvatarquality':
				return {
					...state,
					avatarquality: action.newTheme
				}
			case 'changeMintime':
				return {
					...state,
					mintime: action.newTheme
				}
			case 'changeMaxtime':
				return {
					...state,
					maxtime: action.newTheme
				}
			case 'changeMorningfrom':
				return {
					...state,
					morningfrom: action.newTheme
				}
			case 'changeMorningto':
				return {
					...state,
					morningto: action.newTheme
				}
			case 'changeAfternoonfrom':
				return {
					...state,
					afternoonfrom: action.newTheme
				}
			case 'changeAfternoonto':
				return {
					...state,
					afternoonto: action.newTheme
				}
			case 'changeFriday':
				return {
					...state,
					showfriday: action.newTheme
				}
			case 'changeWeekend':
				return {
					...state,
					showweekend: action.newTheme
				}
			case 'changeLogo':
				return {
					...state,
					applogo: action.newTheme
				}
			case 'changeBgimage':
				return {
					...state,
					bgimage: action.newTheme
				}
			default:
				return state
		}
	}

	const initialState = {
		paper: {
			background: localStorage.getItem('papercolor')
		},
		primary: {
			color: primcolor
		},
		secondary: {
			color: seccolor
		},
		applogo: {
			logosrc: ''
		},
	}

	const muiTheme = createMuiTheme(theme)
	const routes = SwitchRoutes()

	return firebaseInitialized !== false && primcolor ? (
		<Provider reducer={reducer} initialState={initialState}>
			<MuiThemeProvider theme={muiTheme}>
				<Suspense fallback={null}>
					<LanguageSelector />
					<Router>
						<Logo />
						<Themeswitch onToggleDark={toggleDarkTheme} />
						<CssBaseline />
						<BackButton />
						{!isLogged ?
							<div></div>
							:
							<div ref={node}>
								<FocusLock disabled={!open}>
									{!open ?
										<Burger open={open} setOpen={setOpen} aria-controls={menuId} />
										:
										<Openburger open={open} setOpen={setOpen} aria-controls={menuId} />
									}
									<HamburgerMenu open={open} setOpen={setOpen} id={menuId} />
								</FocusLock>
							</div>
						}
						{routes}
					</Router>
				</Suspense>
			</MuiThemeProvider>
		</Provider>
	) : <div id="loader"><CircularProgress /></div>
}

export default App